import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { AppleApplication } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleApplicationApiActions = createActionGroup({
  source: 'Apple Application API',
  events: {
    'Applications loaded': props<{ applications: AppleApplication[] }>(),
    'Applications loaded error': props<{ error: ErrorModel }>(),
    'Application added': props<{ application: AppleApplication }>(),
    'Application added error': props<{ error: ErrorModel }>(),
    'Application upload progressed': props<{ progress: number }>(),
    'Application deleted': props<{ bundleIdentifier: string; version: string }>(),
    'Application deleted error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleApplicationViewActions = createActionGroup({
  source: 'Apple Application view',
  events: {
    'Application added': props<{ application: File }>(),
    'Application deleted': props<{ bundleIdentifier: string; version: string }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleApplicationResolverActions = createActionGroup({
  source: 'Apple Application resolver',
  events: {
    'Applications requested': emptyProps(),
  },
});
